/**
 * One line about what an OFAC SDN match means to an Indian investigator, used by the Actions
 * tab, the Intel tab and the LE report so the three never disagree (NS-42).
 *
 * LEGAL CONFIRMATION (owner): the wording below says the list has no direct force of law in India
 * and that a match is an indicator to corroborate and refer. Please have counsel confirm it
 * (including whether to name ED / FIU-IND as the referral route, and the position on secondary
 * exposure for Indian entities that deal through US-regulated institutions) before external use.
 */
export const OFAC_LIST_NAME = 'US Treasury OFAC SDN list';

/** The reconciled line. Plain text; callers escape it where they put it in HTML. */
export const OFAC_INDICATOR_LINE =
  'OFAC is a US list with no direct force of law in India: a match is a high-priority intelligence indicator to corroborate and refer to the competent Indian authority (for example ED or FIU-IND) under your agency procedure, not an Indian legal prohibition by itself.';

/** Short action label for the Actions tab (the line above is its title / tooltip). */
export const OFAC_ESCALATE_LABEL = 'Escalate sanctions match for review (indicator)';
